import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

// Model $id is the row-unique PK (mapped from xkserier.sysid in foundation).
// The default idAttribute 'id' is correct — no override needed.
export const giftcardSeriesSchema = new schema.Entity('giftcardSeries');

export const giftcardSeries = configureApiEntity('GIFTCARD_SERIES', 'giftcardSeries', giftcardSeriesSchema);
